import { createContext } from 'react';
// eslint-disable-next-line prettier/prettier
var Context = createContext({});
export default Context;
